/**
 * Impersonating the rental-manager-web impersonation nav.
 */

import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

class ImpersonationNav extends React.Component {
  static propTypes = {
    emailAddress: PropTypes.string,
  };

  render() {
    const { emailAddress } = this.props;

    return (
      <div className="ImpersonationNav">
        <span className="ImpersonationNav-bold-red">Impersonating</span>
        {` ${emailAddress}`}
      </div>
    );
  }
}

export default ImpersonationNav;
